import { notify } from '@carboncopyco/ui';
import { getDropzoneAcceptedFormats } from '@carboncopyco/utils';
import { useDropzone } from 'react-dropzone';

const supportedImageFormats = ['JPG', 'JPEG', 'PNG'];
const minResolution = 200;

interface IUseImageProps {
  onImageAdded: (img: string | ArrayBuffer) => void;
}

const useImageProps = ({ onImageAdded }: IUseImageProps) => {
  const customDropzoneOptions = {
    multiple: false,
    maxSize: 10000000,
    minSize: 1024,
    accept: getDropzoneAcceptedFormats(supportedImageFormats, 'image'),
    maxFiles: 1,
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    ...customDropzoneOptions,
    onDropAccepted: (files) => {
      const reader = new FileReader();
      reader.onload = () => {
        const image = new Image();

        image.addEventListener('load', () => {
          onImageAdded(reader.result);
        });
        image.src = reader.result as string;
      };
      reader.readAsDataURL(files[0]);
    },
    onDropRejected: (files) => {
      const {
        errors: [{ code }],
      } = files[0];

      const dispatchError = (err) => notify.error(err, { autoClose: 5000 });

      switch (code) {
        case 'file-too-large':
          return dispatchError(
            'This image is too large, must be lower than 10MB.'
          );
        case 'file-too-small':
          return dispatchError(
            `Image minimum width or height must be higher than ${minResolution} pixels.`
          );
        case 'file-invalid-type':
          return dispatchError(
            `This image format is not supported! supported formats: ${supportedImageFormats.join(
              ','
            )}.`
          );
        default:
          return dispatchError('Something went wrong.');
      }
    },
  });

  return {
    getRootProps,
    getInputProps,
    open,
  };
};

export default useImageProps;
